import { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";

import { CourtResponse } from "@/api";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { useCourts } from "@/common/hooks/useCourts";
import { useTranslation } from "@/translations";

import { CourtCard } from "./components/court-card/CourtCard";
import { CourtCreationDialog } from "./components/court-dialog/CourtCreationDialog";
import { CourtEditDialog } from "./components/court-dialog/CourtEditDialog";
import { useCourtDelete } from "./hooks/useCourtDelete";

function ViennaCourtsInner() {
  const { t } = useTranslation();
  const { courts, isLoading } = useCourts();
  const { confirmAndDelete, isDeleting } = useCourtDelete();

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [courtToEdit, setCourtToEdit] = useState<CourtResponse | null>(null);

  return (
    <Stack spacing={2} sx={{ height: "100%" }} pb={3} overflow="hidden">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1">{t("settings.courts.count", { count: courts.length })}</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setIsCreateDialogOpen(true)}>
          {t("settings.courts.addButton")}
        </Button>
      </Box>

      {courts.length === 0 && !isLoading ? (
        <Typography color="text.secondary">{t("settings.courts.empty")}</Typography>
      ) : (
        <Stack spacing={2} sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
          {courts.map((court) => (
            <CourtCard
              key={court.id}
              court={court}
              onEdit={() => setCourtToEdit(court)}
              onDelete={() => confirmAndDelete(court)}
              isDeleting={isDeleting}
            />
          ))}
        </Stack>
      )}

      {isCreateDialogOpen && <CourtCreationDialog onClose={() => setIsCreateDialogOpen(false)} />}
      {courtToEdit && <CourtEditDialog court={courtToEdit} onClose={() => setCourtToEdit(null)} />}
    </Stack>
  );
}

export const ViennaCourts = withAuthorization(ViennaCourtsInner, UserPermission.Supervisor);
